import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Alert, Button as MuiButton, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Button, FormGroup } from 'reactstrap';
import { useUser } from 'src/hooks/useUser';
import styles from 'src/pages/accueil/styles/style-project.module.scss';
const ProjectForm = (props) => {
  const {
    handleSubmit,
    onSubmit,
    register,
    errors,
    action,
    isDisabled,
    t,
    children,
    onSubmitAdmins,
    selctedAdminForProject,
    currentDevise,
    currentCountry,
  } = props;
  const history = useHistory();

  const formProps = {
    ...(!isDisabled && { onSubmit: handleSubmit(onSubmit) }),
  };

  const { user } = useUser();
  const minDate = new Date('2014-01-01').toISOString().split('T')[0];
  return (
    <form key="form1" className="needs-validation" noValidate {...formProps}>
      <FormGroup key="formgroup1" className="form-row">
        <label htmlFor={'project_name'}>
          {t('Project_Name')} <span>*</span>
        </label>
        <input
          key="input1"
          type="text"
          className="form-control"
          id="project_name"
          aria-invalid={!isDisabled && errors.project_name ? 'true' : 'false'}
          placeholder={t('Enter_Project')}
          {...register('project_name', { required: true })}
          disabled={!user?.isSuperAdmin || isDisabled}  
        />
        {!isDisabled && <span key="span1">{errors.project_name && <p>{t('errors_champ')}</p>}</span>}
      </FormGroup>
      <div key="div1" className="form-row">
      <FormGroup key="formgroup2" className="col-md-6">
          <label key="label1 " htmlFor="project_start_date">
            {t('Start_Date')} <span>*</span>
          </label>
          <input
            key="input2"
            type="date"
            className="form-control digit"
            id="project_start_date"
            min={minDate}
            {...register('project_start_date', { required: true })}
            disabled={!user?.isSuperAdmin || isDisabled}
          />
          {!isDisabled && <span key="span3">{errors.project_start_date && <p>{t('errors_champ')}</p>}</span>}
        </FormGroup>
        <FormGroup key="formgroup3" className="col-md-6">
          <label key="label3 " htmlFor="project_end_date">
            {t('End_Date')} <span>*</span>
          </label>
          <input
            key="input3"
            type="date"
            className="form-control digit"
            id="project_end_date"
            min={minDate}
            {...register('project_end_date', { required: true })}
            disabled={!user?.isSuperAdmin || isDisabled} 
          />
          {!isDisabled && <span key="span4">{errors.project_end_date && <p>{t('errors_champ')}</p>}</span>}
        </FormGroup>
      </div>
      <FormGroup key="formgroup4" className="form-row">
        <label key="label4 " htmlFor="project_description">
          {t('Description')}
        </label>
        <textarea
          className="form-control"
          id="project_description"
          rows={3}
          placeholder={t('more_details')}
          {...register('project_description')}
          disabled={isDisabled}
        ></textarea>
      </FormGroup>

      {user?.isSuperAdmin && (
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '2rem', gap: '3rem' }}>
           {action === 'preview' && (
          <FormGroup key="formgroup5">
          <label>
                {t('admin')} <span>*</span>
              </label>

            <div style={{ display: 'flex', gap: 15 }}>
              {!selctedAdminForProject ? (
                <Alert severity="info">{t('add_admin')}</Alert>
              ) : (
                <Alert severity="success" style={{ textTransform: 'capitalize' }}>
                  {selctedAdminForProject.username}
                </Alert>
              )}

              {action !== 'preview' && (
                <Tooltip title={t('add_admin_desc')}>
                  <MuiButton
                    onClick={onSubmitAdmins}
                    style={{ alignSelf: 'center' }}
                    variant="outlined"
                    startIcon={<PersonAddIcon />}
                  >
                    {!selctedAdminForProject ? t('add') : t('edit')}
                  </MuiButton>
                </Tooltip>
              )}
            </div>
          </FormGroup>
           )}
          {action === 'preview' && (
            <FormGroup key="formgroup7" style={{ display: 'flex', flexDirection: 'column' }} className="form-row">
              <label>
                {t('devise')} <span>*</span>
              </label>
              <div style={{ display: 'flex', gap: 15 }}>
                {currentDevise && currentDevise?.name ? (
                  <Alert severity="success" style={{ textTransform: 'capitalize' }}>
                    {currentDevise?.name} ({currentDevise?.code})
                  </Alert>
                ) : (
                  <Alert severity="info">{t('choose_devise')}</Alert>
                )}
              </div>
            </FormGroup>
          )}
          {action === 'preview' && (
            <FormGroup key="formgroup7" style={{ display: 'flex', flexDirection: 'column' }} className="form-row">
              <label>
                {t('country')} <span>*</span>
              </label>
              <div style={{ display: 'flex', gap: 15 }}>
                {currentCountry && currentCountry?.name ? (
                  <Alert severity="success" style={{ textTransform: 'capitalize' }}>
                    {currentCountry?.name}
                  </Alert>
                ) : (
                  <Alert severity="info">{t('choose_country')}</Alert>
                )}
              </div>
            </FormGroup>
          )}
        </div>
      )}

      {children}

      {!isDisabled && (
        <Button outline color="success" className="float-right" type="submit">
          {t(action)}
        </Button>
      )}
      <Button type="button" className={styles['btn-cancel']} onClick={() => history.push('/project/list')}>
        {props.t('cancel')}
      </Button>
    </form>
  );
};

export default translate(ProjectForm);
